import React from 'react';
import cn from 'classnames';
import { IoSearchOutline } from 'react-icons/io5';
import { getShopProductUrl } from '../../../../helpers/helpers';
import { useUrlDataContext } from '../../lib/UrlDataContext';
import { useActionContext } from '../../lib/ActionContext';
import { Image } from '../Image';
import { SearchProducts } from '../SearchProducts';
import { ActionPanel } from '../../../General/ActionPanel';

const getConfidenceScoreClass = confidenceScore => {
  if (confidenceScore >= 80) return 'good';
  if (confidenceScore >= 50) return 'medium';
  return 'bad';
};

export const MatchToProduct = () => {
  const { currentUrlData, isCurrentUrlBlocked } = useUrlDataContext();
  const { view, setView, setProductId } = useActionContext();

  const bestProductMatch = currentUrlData?.bestProductMatch;

  return (
    <ActionPanel
      header={
        <>
          <div>
            {bestProductMatch?.id && (
              <div className='view-toggle'>
                <button
                  className={cn('ai-match', { current: view === 'best-match' })}
                  onClick={() => setView('best-match')}
                  disabled={isCurrentUrlBlocked}
                >
                  Best match
                  <span
                    title={bestProductMatch.confidenceReason}
                    className={cn('confidence-score', getConfidenceScoreClass(bestProductMatch.confidenceScore))}
                  >
                    {bestProductMatch.confidenceScore}%
                  </span>
                </button>

                <button className={cn('search', { current: view === 'search' })} onClick={() => setView('search')} disabled={isCurrentUrlBlocked}>
                  <IoSearchOutline size={20} />
                  Search
                </button>
              </div>
            )}

            {!bestProductMatch?.id && 'Match'}
          </div>

          <div className='header-action'>
            or{' '}
            <button onClick={() => setView('new-product')} disabled={isCurrentUrlBlocked}>
              New product
            </button>
          </div>
        </>
      }
    >
      {bestProductMatch?.id && view === 'best-match' && (
        <div className='best-match card'>
          <h2 className='title'>
            <span>Best match</span>
            <span
              title={bestProductMatch.confidenceReason}
              className={cn('confidence-score', getConfidenceScoreClass(bestProductMatch.confidenceScore))}
            >
              {bestProductMatch.confidenceScore}% likely
            </span>
          </h2>

          <Image imagePath='bestProductMatch.image' alt={bestProductMatch.name} />

          <div className='product-information'>
            <h3 className='brand-name'>{bestProductMatch.brand}</h3>
            <h2 className='product-name'>
              <a href={getShopProductUrl(bestProductMatch.id)} target='_blank' rel='noopener noreferrer'>
                {bestProductMatch.title}
              </a>
            </h2>
            <p className='category-name'>{bestProductMatch.categoryName}</p>
          </div>

          <div className='actions'>
            <button
              onClick={() => {
                setProductId(bestProductMatch.id);
                setView('edit-product');
              }}
              disabled={isCurrentUrlBlocked}
            >
              Confirm match {currentUrlData.pinCount ? `(${currentUrlData.pinCount})` : ''}
            </button>
          </div>
        </div>
      )}

      {view === 'search' && <SearchProducts />}
    </ActionPanel>
  );
};
